import createIcon from '../createIcon'

export default createIcon(
    'M20,2H4.01c-1.1,0-2,0.89-2,2L2,19.58c0,0.89,1.08,1.34,1.71,0.71L6,18h14c1.1,0,2-0.9,2-2V4C22,2.9,21.1,2,20,2z M7,9h10 c0.55,0,1,0.45,1,1v0c0,0.55-0.45,1-1,1H7c-0.55,0-1-0.45-1-1v0C6,9.45,6.45,9,7,9z M13,14H7c-0.55,0-1-0.45-1-1v0 c0-0.55,0.45-1,1-1h6c0.55,0,1,0.45,1,1v0C14,13.55,13.55,14,13,14z M17,8H7C6.45,8,6,7.55,6,7v0c0-0.55,0.45-1,1-1h10 c0.55,0,1,0.45,1,1v0C18,7.55,17.55,8,17,8z'
)
